<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" dense light app fixed>
    <div class="page-header-left">
      <a href="/">
        <img height="20px" class="ma-3" src="/images/logo.png" />
      </a>
    </div>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn
        class="hidden-xs-only"
        v-for="link in mainMenu"
        :key="link.text"
        text
        color="primary"
        route
        :to="link.route"
      >
        <v-icon left small>{{ link.icon }}</v-icon>
        {{ link.text }}
      </v-btn>
      <v-btn
        :loading="billingLoading"
        text
        color="primary"
        class="hidden-xs-only"
        @click.native="openBilling"
      >
        <v-icon left small>fa-light fa-dollar-sign</v-icon>
        {{ lang.billing }}
      </v-btn>
      <v-btn
        text
        color="primary"
        class="hidden-xs-only"
        href="https://admin-help.cloudhexa.net/"
        target="_blank"
      >
        <v-icon left small>fa-light fa-circle-info</v-icon>
        {{ lang.help }}
      </v-btn>
      <v-btn
        :loading="dataClearingCache"
        dark
        color="primary"
        depressed
        class="mr-4"
        @click.native="clearCache"
        >{{ lang.clear_cache }}</v-btn
      >
    </v-toolbar-items>

    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      :nudge-width="300"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-avatar size="30px" v-on="on">
          <img
            v-if="adminUser.pic"
            :src="adminUser.pic"
            :alt="adminUser.name"
          />
          <v-icon v-else>fa-light fa-user</v-icon>
        </v-avatar>
      </template>

      <v-list>
        <v-list-item>
          <v-layout column class="ma-4">
            <v-flex class="mb-2">{{ adminUser.email }}</v-flex>
            <v-flex class="grey--text">{{ adminUser.name }}</v-flex>
          </v-layout>
        </v-list-item>
        <v-list-item
          v-for="link in profileMenu"
          :key="link.text"
          ripple="ripple"
          rel="noopener"
          router
          :to="link.route"
          @click="link.click"
          :href="link.href"
          :target="link.target"
        >
          <v-list-item-action>
            <v-icon small>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ link.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import { mapState } from "vuex";
const logs = require("@/classes/logs/logs.js").Logs;
var fb;
export default {
  mounted() {
    fb = this.fb;
    this.mainMenu = [
      {
        icon: "fa-light fa-objects-column",
        text: this.lang.dashboard,
        route: "/",
      },
      { icon: "fa-light fa-users", text: this.lang.users, route: "/users" },
      {
        icon: "fa-light fa-money-check-dollar",
        text: this.lang.coupons,
        route: "/coupons",
      },
    ];
  },
  computed: {
    ...mapState([
      "fb",
      "adminUser",
      "lang",
      "notifications",
      "page_name",
      "hasPageHelp",
    ]),
  },
  data() {
    return {
      dataClearingCache: false,
      billingLoading: false,
      drawer: false,
      mainMenu: [],
      profileMenu: [
        {
          icon: "fa-light fa-circle-info",
          text: "Help",
          route: "",
          href: "https://admin-help.cloudhexa.net/",
          target: "_blank",
          click: (e) => {},
        },
        {
          icon: "fa-light fa-arrow-right-from-bracket",
          text: "Logout",
          route: "",
          href: "",
          target: "",
          click: (e) => {
            fb.auth.signOut();
            logs.print(e);
          },
        },
      ],
    };
  },
  methods: {
    openBilling() {
      this.billingLoading = true;
      var me = this;
      var callback = function(res) {
        me.billingLoading = false;
        if (res.status && res.data && res.data.url) {
          window.open(res.data.url, "_blank");
        } else {
          me.$toastr("error", me.lang.error);
        }
      };
      this.adminUser.openBilling(callback);
    },
    clearCache() {
      this.dataClearingCache = true;
      var me = this;
      var callback = function() {
        me.dataClearingCache = false;
      };
      this.adminUser.clearServerCache(callback);
    },
  },
};
</script>
